import { Log, PaginatedApiResponse } from '../../api/models';
import {
  createAction,
  createActionWithPayload,
  IAction,
  IActionWithPayload,
} from '../utils';

const ACTION_LOAD_LOG_REQUEST = 'ENTITIES/LOAD_LOG_REQUEST';
const ACTION_LOAD_LOG_SUCCESS = 'INTENT/LOAD_LOG_SUCCESS';
const ACTION_LOAD_LOG_ERROR = 'INTENT/LOAD_LOG_ERROR';

export interface LogState {
  data?: PaginatedApiResponse<Log>;
  isLoading?: boolean;
  isLoaded?: boolean;
}

const initialState: LogState = {
  isLoading: false,
  isLoaded: false,
};

export interface ILogListingDetails {
  data?: Log[];
  totalCount?: number;
  page?: number;
}

type LoadLogRequestActionType = IAction<typeof ACTION_LOAD_LOG_REQUEST>;

type LoadLogSuccessActionType = IActionWithPayload<
  typeof ACTION_LOAD_LOG_SUCCESS,
  PaginatedApiResponse<Log>
>;

type LoadLogErrorActionType = IAction<typeof ACTION_LOAD_LOG_ERROR>;

type Actions =
  | LoadLogRequestActionType
  | LoadLogSuccessActionType
  | LoadLogErrorActionType;

export const loadLogRequestAction = (): LoadLogRequestActionType => {
  return createAction(ACTION_LOAD_LOG_REQUEST);
};

export const loadLogSuccessAction = (
  data: PaginatedApiResponse<Log>
): LoadLogSuccessActionType => {
  return createActionWithPayload(ACTION_LOAD_LOG_SUCCESS, data);
};

export const loadLogErrorAction = (): LoadLogErrorActionType => {
  return createAction(ACTION_LOAD_LOG_ERROR);
};

// reducer
export const logReducer = (
  state: LogState = initialState,
  action: Actions
): LogState => {
  switch (action.type) {
    case ACTION_LOAD_LOG_REQUEST:
      return {
        ...state,
        isLoading: true,
        isLoaded: false,
      };
    case ACTION_LOAD_LOG_ERROR:
      return {
        ...state,
        isLoaded: true,
        isLoading: false,
      };
    case ACTION_LOAD_LOG_SUCCESS:
      const logs =
        Number(action.payload?.page) <= 1
          ? [...action.payload?.data]
          : [
              ...(state.data?.data ? state.data?.data : []),
              ...action.payload.data,
            ];

      return {
        ...state,
        data: { ...action.payload, data: logs },
        isLoading: false,
        isLoaded: true,
      };
    default:
      return state;
  }
};
